import React, {Component} from 'react'
import {Field} from 'redux-form'
import Font from '@cred/react-font'
import defaultStyles from './themes/default/styles.module.scss'
import credible3 from './themes/credible3/styles.module.scss'
import withStyles from '@cred/react-theme'

class Input extends Component {
  static defaultProps = {
    component: 'input',
    autoFocus: false,
    autoFocusDelay: 500,
    styles: defaultStyles
  }

  componentDidMount() {
    const {autoFocus, autoFocusDelay} = this.props

    if (autoFocus && this.inputRef) {
      setTimeout(this.focus, autoFocusDelay)
    }
  }

  focus = () => this.inputRef.focus()
  setInputRef = (ref) => {
    this.inputRef = ref

    if (this.props.ref) {
      this.props.ref(ref)
    }
  }

  render() {
    const {className, styles, ...props} = this.props

    delete props.autoFocus
    delete props.autoFocusDelay

    return (
      <Font element="div" className={[className, styles.input].join(' ')}>
        <Field getInputRef={this.setInputRef} {...props}/>
      </Font>
    )
  }
}

export {Input as InputNoHoc}

export default withStyles(defaultStyles, {credible3})(Input)
